import React from "react";
import { OPPlayer } from "../OPPlayer";
import { SourceType } from "../Player.types";
import { VideoCover } from "../VideoCover";
import { getMp4Url } from "./utils";
import styles from "./ProgramsVideoPlayer.scss";
const BASE_DATA_HOOK = "programs-video-player";
// was aded because of this: https://wix.slack.com/archives/CQF1SC6MN/p1724313291882689
const END_OF_VIDEO_PROGRESS = 99.99;
export const ProgramsVideoPlayer = props => {
  const {
    className = "",
    isMobile = false,
    customCoverUrl,
    videoData,
    onRequestHLSStreamURL,
    HLSStreamURL,
    isAutoplay = false,
    onPlayerReady,
    onProgress,
    onError,
    onEnd,
    disableSeekForward = false
  } = props;
  const type = videoData.type;
  const finalPoster = customCoverUrl || (videoData == null ? void 0 : videoData.thumbnailUrl) || null;
  const isExternalVideo = ![SourceType.HLS, SourceType.MP4].includes(videoData.type);
  const [playing, setPlaying] = React.useState(false);
  const [src, setSrc] = React.useState("");
  const [isPreview, setIsPreview] = React.useState(!isExternalVideo);
  React.useEffect(() => {
    switch (videoData.type) {
      case SourceType.HLS:
        // do nothing
        break;
      case SourceType.MP4:
        setSrc(getMp4Url(videoData));
        break;
      case SourceType.Youtube:
      case SourceType.Facebook:
      case SourceType.Vimeo:
        setSrc(videoData.url);
        break;
      default:
        setSrc("");
    }
  }, [videoData.id]);
  React.useEffect(() => {
    if (isAutoplay && !isExternalVideo) {
      /*
        For internal videos we just forced the click event to the preview button,
          for external `playing` + `muted` props are using.
       */
      void onPreviewClick();
    } else if (isAutoplay && isExternalVideo) {
      setPlaying(true);
    }
  }, []);
  React.useEffect(() => {
    if (HLSStreamURL) {
      setIsPreview(false);
    }
  }, [HLSStreamURL]);
  const onPreviewClick = React.useCallback(() => {
    // If we are playing HLS *only for the first time*, we need to request the stream url.
    if (videoData.type === SourceType.HLS && !HLSStreamURL) {
      void (onRequestHLSStreamURL == null ? void 0 : onRequestHLSStreamURL());
    } else {
      setIsPreview(false);
    }
  }, [videoData == null ? void 0 : videoData.id, HLSStreamURL, onRequestHLSStreamURL]);
  if (isPreview) {
    return /*#__PURE__*/React.createElement(VideoCover, {
      poster: finalPoster,
      onPlayClick: onPreviewClick,
      className: className,
      dataHook: BASE_DATA_HOOK,
      isMobile: isMobile
    });
  }

  // Vimeo will throw an error if player renders without valid src property.
  if (videoData.type === SourceType.Vimeo && !src && !HLSStreamURL) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.base + (isMobile ? " " + styles.baseMobile : "") + (className ? " " + className : ""),
    "data-hook": BASE_DATA_HOOK
  }, /*#__PURE__*/React.createElement(OPPlayer, {
    type: type,
    poster: finalPoster || undefined,
    src: src || HLSStreamURL || "",
    fallbackSrc: getMp4Url(videoData),
    playing: playing,
    muted: playing // only muted external video could be played w/o user interaction
    ,
    resolutions: videoData.resolutions || undefined,
    onProgress: progress => {
      if (progress >= END_OF_VIDEO_PROGRESS && !isExternalVideo) {
        setIsPreview(true);
        onEnd == null || onEnd();
      }
      onProgress == null || onProgress(progress);
    },
    onPlayerReady: player => {
      onPlayerReady == null || onPlayerReady(player.player);
      if (!isPreview && !isExternalVideo) {
        setTimeout(() => {
          player.player.play();
        }, 100);
      }
    },
    onError: err => {
      if (onError) {
        onError(err);
      } else {
        console.error(err);
      }
    },
    onEnd: () => {
      onEnd == null || onEnd();
    },
    disableSeekForward: disableSeekForward
  }));
};
//# sourceMappingURL=ProgramsVideoPlayer.js.map